export default __webpack_public_path__ + "src/appV2/Shifts/Shift/TakeClockActionPicture/images/timeclock_biometric_compliance.png";